import type { FaireProductEntity } from "../../entity_types/product";

export const caden_lane_9: FaireProductEntity = {
  token: "caden-lane-9",
  type: "product",
  name: "Silicone Play Kitchen Sets",
  brandName: "Caden Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/d95641b11dff79cf5e9a59a190b8125894530e5e05e9964466457eee43487dc4.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 28,
  msrpDollars: 56,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
